import React from 'react';
import { Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  // TODO: Replace with actual WhatsApp number (format: 966XXXXXXXXX without +)
  const phoneNumber = '966XXXXXXXXX'; // Replace with actual WhatsApp number
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <Fab
      color="primary"
      aria-label="Contact on WhatsApp"
      onClick={handleClick}
      sx={{
        position: 'fixed',
        bottom: 30,
        left: { xs: 20, md: 30 },
        bgcolor: '#25D366',
        '&:hover': {
          bgcolor: '#1ea952',
          boxShadow: '0 6px 20px rgba(37, 211, 102, 0.6)',
          transform: 'scale(1.1)',
        },
        zIndex: 999,
        boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
        transition: 'all 0.3s ease',
      }}
    >
      <WhatsAppIcon sx={{ color: 'white' }} />
    </Fab>
  );
};

export default WhatsAppButton;
